let portalURL = window.location.href;
let domain = new URL(portalURL).origin;

const baseConfig = {
  production: true,
  themeVariable: "fidivio",
  version: "0.0.16",
  apiendpoint: {
    url: domain,
    version: "v1/",
    endpoint: "/api/",
  },
  host: function () {
    return (
      this.apiendpoint.url +
      this.apiendpoint.endpoint +
      this.apiendpoint.version
    );
  },
  hostv2: function () {
    return this.apiendpoint.url + this.apiendpoint.endpoint + "v2/";
  },
};

// Map of hostnames → credentials
const domainConfig: Record<
  string,
  { client_id: string; client_secret: string }
> = {
  "fidivioqa1.devint36.gravty.info": {
    client_id: "9KCU4pRuoGwjW4Cwc7JIqB0bTQWiPJN88CSpplKzgIc",
    client_secret: "aJyC2_V0k4kv64W8ew5xnmdV51S2wL8tbW5KaMlAy_c",
  },
  "fidiviodemov1.devint36.gravty.info": {
    client_id: "cz7Xed263cNejHI85tCwm9wM6gN8rH3I5v8WDjTJaxg",
    client_secret: "cc3ZhXuW-B-EcEgl04304IuLq43gOduKpb9qiUSfcMw",
  },
  "fidiviodemov3.devint36.gravty.info": {
    client_id: "QT__MKVmN8rdBnzi3uvEIL-fLw_hBT99pQv4Uv9yUQI",
    client_secret: "CBsg-g4rMjPeyPIh9vuDzPaXl2Tmb5eRAgRC8btR4uw",
  },
  "fidiviodemov2.devint36.gravty.info": {
    client_id: "XEVwPgdgRmlIK-PTanZWQNl8MwcJ7xyflGO0VL8kkec",
    client_secret: "JChJ4QzwcyDub9Q4m1QqrgOBAlS8ctcirNuKitfKLzo",
  },
  "fidiviosandboxv1.devint36.gravty.info": {
    client_id: "Jzvd1UW8Ki-pfmu6i2E5-OL6fkfOELsC_0g2Wp1jx50",
    client_secret: "ixieQnh084zenJylHPgGv6XGF9Tq6OjdfWmBLKyvZDw",
  },
  "fidiviosandboxv2.devint36.gravty.info": {
    client_id: "Qhw9S8093GvzDP5eTxeHH00UvGk-YH9gl1SxpdUg6y8",
    client_secret: "J9zxPGNPoOHe3r-QPqpTKxtscgvpiH4Yujx4C5DY6ww",
  },
  "fidiviocabv1.devint36.gravty.info": {
    client_id: "1JxQplyBgDvL27mjEgwlt0mQxlp1nuHU7aL_nRH2SNs",
    client_secret: "42cGXP5Jq__lkGp9UR-wiuCy4CiA9m130dxLP9CFbLk",
  },
  "fidiviotpremia.uso24.gravty.io": {
    client_id: "yeRjrAvT2iw8BBGKRfli7OeVRlj2nLpLcZOe7qDDbic",
    client_secret: "BzYcFHny_Jwr0mCzSHREl9BR-wtmrA4KoPtdsEQg93o",
  },
  "tpremia.fduso1.fidivio.com": {
    client_id: "Y8ys6SPa0UziFIbGLYXwZhYVCC93b55udhkK2sxUapQ",
    client_secret: "MGHIJIIxnlvUeaIwCFK7veD_V_Jbf1sPTEx35bXHE8Q",
  },
  "fidiviotpremiatest.uso24.gravty.io": {
    client_id: "CvUSYOzbD6-_cUPBlhRRnEBRbs1_t7cEX_t89hObFbM",
    client_secret: "1bcbOJKmiQp78QsHb3E8YDb7I-bwI7l0tw7pgdTfiQU",
  },
  "fidiviodevint2.devintbo1.gravty.info": {
    client_id: "7q_v60rdT0kLSHH9N6JB4T5lb_kxiVhkOeyt1Qbi5Ro",
    client_secret: "pvTLexJDbCdhI2H1Sw7AJwr_hE8rTiU3b1Nqv-2pQ5w",
  },
  "fidiviosandbox.saudia.fidivio.com": {
    client_id: "FZ-cbvpSl5jeVobflOcw-AFYpJeqTDrHmATEuo7W1ts",
    client_secret: "0vydQvsG48Wyo3Rzl0QWiuUxPe7Li9ckDFlUTF1p0x4",
  },
  "fidiviosandbox.melia.fidivio.com": {
    client_id: "jjY5GZdQYzVd0aSU62kPpmHHZg9JiUio4OriYZH58d8",
    client_secret: "IZ7VAf33y8LNBDh1JPMCeCHhp3k2TR623Cmg8i0tLms",
  },
  "fidiviosandbox.airtransat.fidivio.com": {
    client_id: "WUd3xup2rUpfgmHip7zsIorC6cIS_KRZ-TdMl5mrr4o",
    client_secret: "3cB35RGwDXUI2Pg1m_BOoVsZwbMrled-AZCFnVmdCxk",
  },
  "fidiviosandbox.riyadhair.fidivio.com": {
    client_id: "cSk51tddNsJJV1sut05XObcxr3jPZEBJ-h1krr1Z0zE",
    client_secret: "Lcy1q0uqw-r-VUmD-yszJFgYEhy3hC0tN7UCCrQobgg",
  },
  "fidiviosandbox.easyjet.fidivio.com": {
    client_id: "rhB5Q1SK8kadmz3CZMH3R1HuCJqfh_vnXi6ixzgb87c",
    client_secret: "gCsoOJjARNeYvrGgMxXKq3EeCQgucecolC8Pz81rO1Q",
  },

  default: {
    client_id: "zlVSnS-mulpoaxHpViLBuT-bCT9SoxjO7BMIKY6gM7s",
    client_secret: "dFjbEdd-Zy0KOfpcsuPCS_C2l9UDGVI9oq5nXHUaolg",
  },
};

// Extract hostname (without protocol)
const hostname = new URL(portalURL).hostname;

// Merge base + specific config
const envVariable = {
  ...baseConfig,
  ...(domainConfig[hostname] || domainConfig["default"]),
};

export const environment = envVariable;
